module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/object/assign.js
// module id = 107
// module chunks = 95715928098905 168707334958949